module.exports = __webpack_public_path__ + "img/mairieParieLogo.e0ea9cc5.svg";